import { useQuery } from '@tanstack/react-query';

import { isNotNull } from '../cms/helpers/isNotNull';

import { fetchNavigation } from './api';
import { type MegaNav } from './types';
import {
  getContentfulNavId,
  getFallbackNavConfig,
  getNavConfigQueryKey,
} from './utils';

import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';
import { type SupportedLocation } from '@/modules/location/constants';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';

export function useNavConfig() {
  const { location } = useCurrentLocation();
  const { language } = useCurrentLanguage();

  const { data, isLoading } = useQuery<MegaNav>({
    queryKey: getNavConfigQueryKey(language, location),
    queryFn: () =>
      fetchNavigation(
        getContentfulNavId(location as SupportedLocation, language)
      ),
  });

  const sanitisedMeganav = data?.filter(isNotNull);

  const config = sanitisedMeganav?.length
    ? sanitisedMeganav
    : getFallbackNavConfig(location as SupportedLocation);

  return { config, isLoading };
}
